import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import background from "../assets/background.png";
import GameResult from "./GameResult";
import GameResultTest from "./GameResultTest";
import UpdateProgress from "../functions/UpdateProgress";
import LoadingScreen from "./LoadingScreen";
import useAuth from "../../auth/hooks/useAuth";
import { Scale } from 'react-scaling';
import game_data from "../../games/game_data";
import Rankings from "../hooks/useRankings";
import useTamagotchis from "../hooks/useTamagotchis";

import endgamebg from "../assets/maths_assessments/assets/endgame.png";

export default function PracticeGame({ ...props }) {
    //console.log(props);
        return Game(props);
}

var useTimer = true;
var total_time = 0;

function Game({ ...props }) {
    function ReturnGameID(){
        var id = 0;
        var game = props.parent.gameType;
        for (let i = 0; i < props.gameData.length; i++) {
            const element = props.gameData[i];
            if (game == element.game_type){
                id = element.id;
                break;
            }
        }
        return id;
    }
    var gottama = false;

    const tamagotchis = useTamagotchis();
    const [tama, setTama] = useState([]);
    useEffect(() => {
    if (tamagotchis != undefined && gottama == false) {
        console.log("set tama");
           setTama(tamagotchis);
           gottama = true;
        }
    }, [tamagotchis]);

    const [remainingTime, setRemainingTime] = useState(
        props.defaultTimer ? props.defaultTimer : 30
    );

    
    if (props.defaultTimer == -1){
        //console.log(props.defaultTimer);
        //console.log("FALSE");
        useTimer =false;
    }else{
        //console.log(props.defaultTimer);
        //console.log("TRUE");
        useTimer = true;
    }
    const [showFeedback, setShowFeedback] = useState(false);
    const { state: authState } = useAuth();

    const [remainingQuestions, setRemainingQuestions] = useState(
        props.questionLimit ? props.questionLimit : -1
    );

    const [answerTime, setAnswerTime] = useState(0);

    props.rankings = [];
    if (props.parent.gameType == "multiplication") {
        props.rankings = Rankings({ service_key: "timetables" });
    } else {
        props.rankings = Rankings({ service_key: props.parent.gameType });
    }
    props.token = authState;
    props.gameData = game_data;


    useEffect(() => {
        if(remainingQuestions < 0)
        {
        if (useTimer == true){
            if (remainingTime > 0 || props.questionNumMax) {
                var timerID = setInterval(() => decrementTimer(), 1000);
                return () => {
                    clearInterval(timerID);
                };
            } else {

            //UpdateProgress(props);


            let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correct.length + incorrect.length)).toFixed(2);
            let total_time_taken =  total_time.toFixed(2);

            let correctByTopics = correct.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});
            let incorrectByTopics = incorrect.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});

            window.correctByTopics = correctByTopics;
            window.incorrectByTopics = incorrectByTopics;

            let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
                let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
                let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
                let tempTopicID = parseInt(topic_id);
                let tempAverageAnswerTime = parseFloat(average_ans_time);
                let totalTime = parseFloat(total_time_taken);
                return {
                    topic_id: tempTopicID,
                    num_correct,
                    num_asked: num_correct + num_incorrect,
                    average_ans_time: tempAverageAnswerTime,
                    total_time_taken: totalTime
                }
            });

            console.log(props);
        }
    }
    }
    }, [remainingTime]);


var correctAmount = props.correct ? props.correct.length : 0;
var incorrectAmount = props.incorrect ? props.incorrect.length : 0;
var answeredTotal = correctAmount + incorrectAmount;


    useEffect(() => {
        if(remainingQuestions > 0)
        {
        if (remainingQuestions == answeredTotal) 
        {
            setRemainingTime(0);
            //UpdateProgress(props);

            let average_ans_time = parseFloat((props.defaultTimer ? props.defaultTimer : 30) / (correct.length + incorrect.length)).toFixed(2);
            let total_time_taken = total_time.toFixed(2);

            let correctByTopics = correct.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});
            let incorrectByTopics = incorrect.reduce((byTopics, question) => {
                byTopics[question.topic_id] = byTopics[question.topic_id] || [];
                byTopics[question.topic_id].push(question);
                return byTopics;
            }, {});

            window.correctByTopics = correctByTopics;
            window.incorrectByTopics = incorrectByTopics;

            let topicstats = [...(new Set([...Object.keys(correctByTopics), ...Object.keys(incorrectByTopics)]))].map(topic_id => {
                let num_correct = correctByTopics[topic_id] ? correctByTopics[topic_id].length : 0;
                let num_incorrect = incorrectByTopics[topic_id] ? incorrectByTopics[topic_id].length : 0;
                let tempTopicID = parseInt(topic_id);
                let tempAverageAnswerTime = parseFloat(average_ans_time);
                let totalTime = parseFloat(total_time_taken);
                return {
                    topic_id: tempTopicID,
                    num_correct,
                    num_asked: num_correct + num_incorrect,
                    average_ans_time: tempAverageAnswerTime,
                    total_time_taken: totalTime
                }
            });

            console.log(props);
        }
    }
    }, [answeredTotal]);
 

    useEffect(() => {
            var secondTimerID = setInterval(() => incrementTimer(), 1000);
            return () => {
                clearInterval(secondTimerID);
            };
	});

  //effect here --------------------------------------------
    useEffect(() => {
    total_time = total_time + answerTime;
    setAnswerTime(0);   
	}, [props.correct.length])


    function decrementTimer() {
        if(remainingQuestions < 0 && remainingTime > 0)
        {
        setRemainingTime(remainingTime - 1);
        }
    }

    function incrementTimer(){
      setAnswerTime(answerTime + 1);
	}

    function restartGame() {
        props.restart();
        setRemainingTime(props.defaultTimer ? props.defaultTimer : 30);
    }

    function resetTimer(){
     total_time = 0;
	}

    function TimerZero() {
        if (remainingTime != 0){
           setRemainingTime(0);
           console.log("I submitted on a timeout");
           props.SubmitMethod();
        }
    }



    function QuestionNumberDisplay(){
        //console.log("hello");
        if (props.questionNum >= props.questionNumMax){
            return "";
        }else{
            return props.questionNum+1 +"/"+ props.questionNumMax; 
        }
    }

    function ShowRemainingTime(){
        if (useTimer){
            return remainingTime;
        }else{
            return "∞";
        }
    }


    const {
        children,
        correct,
        incorrect,
        score,
        onBack,
        loading,
        feedback,
        questionFontSize
    } = props;

    return (
        <ApplicationContainer style={{ zindex: 10 }}>
            <AppearAbove id="namedthis">
                <ApplicationHeader>
                    <LeftHeader>
                        <div>{QuestionNumberDisplay()}</div>
                    </LeftHeader>
                    <CenterHeader>
                        <Timer>{ShowRemainingTime()}</Timer>
                    </CenterHeader>
                    <RightHeader>
                    </RightHeader>
                </ApplicationHeader>
            </AppearAbove>
            {((remainingTime > 0 || useTimer == false) && props.gameOver == false) && !loading ? (
                children
            ) : loading ? (
                <LoadingScreen />
            ) : (
                        <EndScreen>
                            {TimerZero()}
                            <Button onClick={() => {
                            props.onBack();
                            resetTimer();
                            }} 
                            style={{ textAlign: "center", fontSize: "10em" }}>
                            Exit
                            </Button>
                        </EndScreen>
                    )}
        </ApplicationContainer>
    );
}


const AppearAbove = styled.div`
z-index: 15;


`

const EndScreen = styled.div`
        width: 100%;
        height: 100%;
        background-image: url(${endgamebg});
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const ApplicationContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 11;
    background: #fff;
`;

const ApplicationHeader = styled.div`
    width: 100%;
    height: 60px;
    background: #683d8c;
    justify-content: space-around;
    display: flex;
    z-index: 11;
`;

const LeftHeader = styled.div`
    width: 30%;
    display: flex;
    justify-content: flex-end;
    font-size: 3em;
    font-weight: 600;
    color: #fff;
    z-index: 11;
`;

const RightHeader = styled.div`
    width: 30%;
    display: flex;
    z-index: 11;
`;

const CenterHeader = styled.div`
    width: 30%;
    display: flex;
    justify-content: center;
    z-index: 11;
`;

const Timer = styled.div`
    width: 200px;
    height: 80px;
    background: #ef3e37;
    text-align: center;
    font-size: 3em;
    font-weight: 600;
    color: #fff;
    line-height: 80px;
    margin-top: 0px;
    border-radius: 0px 0px 15px 15px;
    z-index: 11;
`;

const ApplicationBody = styled.div`
    width: 100%;
    height: 100%;
    background: #2a64a4;
    background-image: url(${background});
    background-size: cover;
    background-position: 0px -1px;
`;

const ApplicationResult = styled.div`
    height: 100%;
    z-index: 10;
    background: #fff;
    background-image: url(${background});
    padding: 150px;
    font-size: 3em;
    border: solid 2px #683d8c;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const IncorrectCount = styled.div`
    margin-top: 10px;
    width: 50px;
    height: 40px;
    background: #ef3e37;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
`;

const CorrectCount = styled.div`
    width: 50px;
    height: 40px;
    margin-top: 10px;
    background: #42b231;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
    border-radius: 5px;
`;

const Score = styled.div`
    width: 150px;
    height: 40px;
    margin-top: 10px;
    background: #4b2e6b;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
    border-radius: 20px;
`;

const Back = styled.div`
    width: 150px;
    height: 40px;
    margin-top: 10px;
    background: #4b2e6b;
    user-select: none;
    text-align: center;
    font-size: 2em;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
    border-radius: 20px;
    &:hover {
        cursor: pointer;
    }
`;

const ResultScores = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 30px;
    flex-direction: column;
`;

const Result = styled.div`
    display: flex;
`;
const ResultValue = styled.div`
    margin: 0px 20px;
    border: solid #e4e4e4 2px;
    background: #fff;
    padding: 0px 15px;
`;

const Banner = styled.div`
    position: absolute;
    left: 50%;
    display: block;
    margin: 100px -200px;
    width: 400px;
    height: 60px;
    border: 1px solid #e88f12;
    font: normal 30px/60px;
    line-height: 60px;
    font-weight: 600;
    text-align: center;
    color: #fff;
    background: rgba(255, 186, 32, 1);
    border-radius: 4px;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.15) inset, 0 6px 10px rgba(0, 0, 0, 0.15);
    &::before,
    ::after {
        content: "";
        position: absolute;
        z-index: -1;
        left: -70px;
        top: 24px;
        display: block;
        width: 40px;
        height: 0px;
        border: 30px solid #e88f12;
        border-right: 20px solid #c97e11;
        border-bottom-color: #e88f12;
        border-left-color: transparent;
        transform: rotate(-5deg);
    }

    &::after {
        left: auto;
        right: -70px;
        border-left: 20px solid #c97e11;
        border-right: 30px solid transparent;
        transform: rotate(5deg);
    }
`;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }

      user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;
